import Vue from 'vue';
import VueScreen from 'vue-screen';

export default function({ app }) {
  let options = {"xs":"375px","sm":"640px","md":"768px","lg":"1024px","xl":"1280px","2xl":"1536px","-xs":{"max":"374px"},"-sm":{"max":"639px"},"-md":{"max":"767px"},"-lg":{"max":"1023px"},"-xl":{"max":"1279px"},"-2xl":{"max":"1535px"},"tablet":(screen) => screen.md && !screen.xl};
  if (typeof options === 'object' && Object.keys(options).length === 0) {
    options = '';
  }

  Vue.use(VueScreen, options);
  app.$screen = Vue.prototype.$screen;
};
